import { Component, signal, ViewChild } from '@angular/core';
import { ModalComponent } from '@peca/design-system';
import {
  ConciliationFailure,
  ConciliationStep,
  InvoiceItemRef,
  ItemMatchStatus,
  ItemsFailurePerOrder,
  ItemsFailureReason,
} from '../../../models/fiscal/inbound-invoice.model';

const CONCILIATION_STEP_LABEL: Record<ConciliationStep, string> = {
  COMMERCE_REFERENCE: 'Referência comercial',
  PURCHASE_ORDER_ID_PREFIX: 'Prefixo do pedido',
  CNPJ: 'CNPJ',
  FISCAL_ARCHIVED: 'Pedido arquivado',
  TOTAL_AMOUNT: 'Valor total',
  ITEMS: 'Itens divergentes',
};

const ITEMS_REASON_LABEL: Record<ItemsFailureReason, string> = {
  ITEM_COUNT_MISMATCH: 'Quantidade de itens diferente',
  ITEM_NOT_FOUND: 'Item do pedido não encontrado na NF',
  QUANTITY_MISMATCH: 'Quantidade divergente',
};

const ITEM_STATUS_LABEL: Record<ItemMatchStatus, string> = {
  MATCHED: 'OK',
  NOT_FOUND: 'Não encontrado na NF',
  QUANTITY_MISMATCH: 'Quantidade divergente',
};

@Component({
  selector: 'peca-fiscal-panel-modal-conciliation-failure',
  templateUrl: './fiscal-panel-modal-conciliation-failure.component.html',
  styleUrls: ['./fiscal-panel-modal-conciliation-failure.component.scss'],
  standalone: false,
})
export class FiscalPanelModalConciliationFailureComponent {
  @ViewChild('modal') modal!: ModalComponent;

  failure = signal<ConciliationFailure | null>(null);
  invoiceCode = signal<string>('');
  commerceReference = signal<string>('');

  stepLabel = (step: ConciliationStep) => CONCILIATION_STEP_LABEL[step] ?? step;
  reasonLabel = (reason: ItemsFailureReason | undefined) => (reason ? ITEMS_REASON_LABEL[reason] ?? reason : '');
  statusLabel = (status: ItemMatchStatus | undefined) => (status ? ITEM_STATUS_LABEL[status] ?? status : '—');

  isMismatch = (status: ItemMatchStatus | undefined) => !!status && status !== 'MATCHED';

  unmatchedInvoiceItemsFor(entry: ItemsFailurePerOrder): InvoiceItemRef[] {
    const matchedSeqs = new Set(
      (entry.items ?? []).map((i) => i.matchedInvoiceItem?.seq).filter((seq): seq is number => seq != null),
    );
    return (entry.unmatchedInvoiceItems ?? []).filter((i) => i.seq == null || !matchedSeqs.has(i.seq));
  }

  open(failure: ConciliationFailure, invoiceCode: string, commerceReference: string) {
    this.failure.set(failure);
    this.invoiceCode.set(invoiceCode);
    this.commerceReference.set(commerceReference);
    this.modal.open();
  }

  onDismiss() {
    this.modal.close();
    this.failure.set(null);
    this.invoiceCode.set('');
    this.commerceReference.set('');
  }
}
